import React, {useState} from 'react';
import {Linking, TouchableWithoutFeedback, View} from "react-native";
import {TranslationView} from "@levelapp/softfabric-ui";
import {styles} from "./MyProfileButtonViewStyle";

interface MyProfileButtonViewProps {
    isVisible: boolean;
    divStyle: any;
}

export default function MyProfileButtonView({isVisible, divStyle}: MyProfileButtonViewProps) {
    const [isHovered, setIsHovered] = useState(false);

    const visibleHrefStyle = isHovered ? styles.buttonHover : styles.buttonDefault;

    function onMyProfilePress() {
        Linking.openURL("https://my.beebonds.com/fr-BE/dashboard");
    }

    return isVisible ? (
        <TouchableWithoutFeedback
            onPressIn={() => setIsHovered(true)}
            onPressOut={() => setIsHovered(false)}
            onPress={onMyProfilePress}
        >
            <View style={[styles.button, visibleHrefStyle, {paddingVertical: 3}]}>
                <TranslationView
                    style={[styles.buttonText, isHovered ? styles.buttonTextHover : styles.buttonTextDefault]}>myprofile</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    ) : (
        <TouchableWithoutFeedback onPress={onMyProfilePress}>
            <View style={[styles.buttonDefault, divStyle, {paddingVertical: 3}]}>
                <TranslationView
                    style={styles.buttonTextMobile}>myprofile</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    );
}